import { brandPrimary, header } from '../../../web/styles/colors';
import { CssSelectors } from '../../../web/styles/styles';
import { StyleSheet } from 'aphrodite';

const InterCardSpacing = 10;
export const styleSheet = StyleSheet.create({
	activeUse: {
		paddingLeft: 20,
		paddingRight: 20,
	},
	addContactModalAddButton: {
		alignItems: 'center',
		color: brandPrimary,
		display: 'flex',
		fontSize: 14,
	},
	addContactModalAddButtonIcon: {
		marginRight: '0.5rem',
	},
	addContactModalFooter: {
		display: 'flex',
		paddingTop: '1rem',
		...CssSelectors.allChildren(
			{
				marginLeft: '0.5rem',
			},
			':not(:first-child)'
		),
	},
	addContactModalHeader: {
		color: header,
		fontSize: '0.875rem',
		textTransform: 'uppercase',
	},
	addContactModalRoot: {
		display: 'flex',
		flexDirection: 'column',
		...CssSelectors.allChildren(
			{
				marginTop: '0.5rem',
			},
			':not(:first-child)'
		),
	},
	addContactModalSavingSpinner: {
		marginRight: '0.5rem',
	},
	cards: {
		overflow: 'hidden',
	},
	cardsContent: {
		alignItems: 'center',
		display: 'flex',
		flexWrap: 'wrap',
		marginLeft: -InterCardSpacing,
		marginRight: -InterCardSpacing,
		paddingTop: 20,
		...CssSelectors.allChildren({
			marginBottom: InterCardSpacing,
			marginLeft: InterCardSpacing,
			marginRight: InterCardSpacing,
		}),
	},
	container: {},
	icon: {
		height: 120,
		width: 120,
	},
});
